var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import React from "react";
import { ModalFormFormat } from "../../UI/FormFormat/FormFormat";
import PersonMergeService from "../../../Services/PersonMerge.service";
import { AlertSuccess } from "../../UI/StandardAlerts/StandardAlerts";
const DuplicateAutoMergeModal = (_a) => {
    var { ruleSetId } = _a, modalProps = __rest(_a, ["ruleSetId"]);
    return (_jsx(ModalFormFormat, Object.assign({}, modalProps, { modalTitle: "Auto Merge", handleSubmit: () => PersonMergeService.autoMerge(ruleSetId), saveButtonContents: "Merge", keepModalOpenAfterSuccess: _jsx(AlertSuccess, { message: "Duplicates are being merged in the background.  It may take some time for these merges to be reflected. " }), children: _jsx("div", { className: "form-group", children: _jsx("div", { children: "By clicking \"Merge\" every duplicate for this Rule Set in the Auto Mergeable tab will be merged, left into right." }) }) })));
};
export default DuplicateAutoMergeModal;
